export default {
  "agentApprovalHistory.title": "Agent Approval",
  "agentApprovalHistory.thead.index": "#No",
  "agentApprovalHistory.thead.applyId": "ApplyId",
  "agentApprovalHistory.thead.userno": "Userno",
  "agentApprovalHistory.thead.email": "Email",
  "agentApprovalHistory.thead.statusDesc": "Status",
  "agentApprovalHistory.thead.applyTime": "ApplyTime",
  "agentApprovalHistory.thead.approvalTime": "ApprovalTime",
  "agentApprovalHistory.thead.applyTimeFrom": "ApprovalStartTime",
  "agentApprovalHistory.thead.applyTimeTo": "ApprovalEndTime",
  "agentApprovalHistory.thead.operator": "Operator",
  "agentApprovalHistory.thead.action": "Action",
  "agentApprovalHistory.tooltip.copyUserNo": "CopyUserNo",
  "agentApprovalHistory.tooltip.userDetails": "UserDetails",
};
